// Pure precedence/normalize rules for admin-uploadable app branding — the
// in-app logo (BrandMark emblem) and the browser favicon. Mirrors
// imageOverrideLogic.mjs for the landing-page images: kept framework-free
// and separate from BrandingContext.jsx so the rules are covered by
// node --test rather than implied by whatever the provider happens to do.

/**
 * Normalize whatever GET /api/public/branding (its `data` field) returned
 * into the exact { logo, favicon } shape every caller expects. A missing,
 * empty, or non-string value becomes null ("no override → bundled
 * default"), so no call site has to special-case a malformed payload.
 *
 * @param {unknown} raw
 * @returns {{ logo: string | null, favicon: string | null }}
 */
export function normalizeBranding(raw) {
  const d = raw && typeof raw === 'object' && !Array.isArray(raw) ? raw : {};
  const asStr = (v) => (typeof v === 'string' && v.length > 0 ? v : null);
  return { logo: asStr(d.logo), favicon: asStr(d.favicon) };
}

/**
 * The one precedence rule every branding image follows: an explicit
 * override wins, a falsy override (missing/null/empty — the shape a "reset
 * to default" save produces) falls back to the bundled default, and with
 * no default either the caller gets null.
 *
 * @param {string | null | undefined} override
 * @param {string | null | undefined} fallback
 * @returns {string | null}
 */
export function resolveBranding(override, fallback) {
  return override || fallback || null;
}
